import Microgame from '../engine/Microgame.js';

export default class ZipperGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Ferme !`, en: `Zip!`, es: `¡Sube la cremallera!` },
            controls: { fr: `Glisse ton doigt le long de la fermeture`, en: `Swipe up along the zipper`, es: `Desliza a lo largo de la cremallera` },
            objective: { fr: `Ferme la veste entièrement`, en: `Zip the jacket all the way up`, es: `Sube la cremallera de la chaqueta por completo` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--secondary-color)" stroke-width="2"><path d="m14 10-2-2 2-2M10 10l2-2-2-2"/><path d="M12 12v10M11 8h2v4h-2z"/></svg>`,
            actions: [
                { type: 'wait', duration: 280 },
                { type: 'swipe', fromX: 50, fromY: 76, toX: 50, toY: 14, duration: 920 },
                { type: 'wait', duration: 420 },
            ],
            loopDuration: 3000
        };
    }
    constructor(engine) {
        super(engine);
        this.zipper = null;
        this.slider = null;
        this.progress = 0;
        this.isDragging = false;
        this.startY = 0;
        this.startTop = 0;
        this.isJamming = false;
        
        // 50% chance to Zip Up vs Zip Down
        this.targetDirection = this.isPlayback ? 'UP' : (Math.random() > 0.5 ? 'UP' : 'DOWN');
        
        // Difficulty scaling
        const speedMult = engine.speedMultiplier || 1.0;
        const adjustedSpeed = 1 + (speedMult - 1) * (2.3 / 3); 
        this.duration = 3000 * (speedMult / adjustedSpeed);

        // 15% chance PER ROUND to jam once - Disabled above speed 3.0
        this.isJamRound = this.isPlayback ? false : ((speedMult <= 3.0) && (Math.random() < 0.15));
        this.jamAtProgress = 0.3 + Math.random() * 0.4;
        this.jamResolved = false;
    }

    setup() {
        this.engine.ui.instruction.textContent = this.targetDirection === 'UP' ? "ZIP UP!" : "ZIP DOWN!";

        // Fabric Background
        const leftFabric = document.createElement('div');
        leftFabric.style.position = 'absolute';
        leftFabric.style.width = '50%';
        leftFabric.style.height = '100%';
        leftFabric.style.left = '0';
        leftFabric.style.top = '0';
        leftFabric.style.background = this.primaryColor;
        leftFabric.style.opacity = '0.1';
        leftFabric.style.boxShadow = `inset -5px 0 10px ${this.primaryColor}`;
        this.container.appendChild(leftFabric);

        const rightFabric = leftFabric.cloneNode();
        rightFabric.style.left = '50%';
        rightFabric.style.background = this.secondaryColor;
        rightFabric.style.boxShadow = `inset 5px 0 10px ${this.secondaryColor}`;
        this.container.appendChild(rightFabric);

        // Zipper Teeth Container
        this.zipper = document.createElement('div');
        this.zipper.style.position = 'absolute';
        this.zipper.style.width = '40px';
        this.zipper.style.height = '80%';
        this.zipper.style.top = '10%';
        this.zipper.style.left = '50%';
        this.zipper.style.transform = 'translateX(-50%)';
        this.container.appendChild(this.zipper);

        // Generate Teeth
        for (let i = 0; i < 20; i++) {
            const toothL = document.createElement('div');
            toothL.style.position = 'absolute';
            toothL.style.width = '15px';
            toothL.style.height = '8px';
            toothL.style.background = this.primaryColor;
            toothL.style.left = '0';
            toothL.style.top = `${i * 5}%`;
            toothL.style.borderRadius = '2px';
            toothL.style.boxShadow = `0 0 5px ${this.primaryColor}`;
            toothL.dataset.index = i;
            this.zipper.appendChild(toothL);

            const toothR = toothL.cloneNode();
            toothR.style.left = 'auto';
            toothR.style.right = '0';
            toothR.style.top = `${i * 5 + 2.5}%`;
            toothR.style.background = this.secondaryColor;
            toothR.style.boxShadow = `0 0 5px ${this.secondaryColor}`;
            this.zipper.appendChild(toothR);
        }

        // Slider
        this.slider = document.createElement('div');
        this.slider.style.position = 'absolute';
        this.slider.style.width = '50px';
        this.slider.style.height = '80px';
        this.slider.style.background = this.primaryColor;
        this.slider.style.border = `2px solid ${this.secondaryColor}`;
        this.slider.style.borderRadius = '10px';
        this.slider.style.left = '50%';
        
        // Initial position based on goal
        if (this.targetDirection === 'UP') {
            this.slider.style.bottom = '10%';
        } else {
            this.slider.style.top = '10%';
        }
        
        this.slider.style.transform = 'translateX(-50%)';
        this.slider.style.cursor = 'grab';
        this.slider.style.touchAction = 'none';
        this.slider.style.boxShadow = `0 0 15px ${this.primaryColor}, inset 0 0 10px ${this.secondaryColor}`;
        this.container.appendChild(this.slider);

        const tab = document.createElement('div');
        tab.style.position = 'absolute';
        tab.style.width = '20px';
        tab.style.height = '40px';
        tab.style.background = this.secondaryColor;
        tab.style.bottom = '-30px';
        tab.style.left = '50%';
        tab.style.transform = 'translateX(-50%)';
        tab.style.borderRadius = '0 0 10px 10px';
        tab.style.boxShadow = `0 0 10px ${this.secondaryColor}`;
        this.slider.appendChild(tab);

        // Bind events
        this.onDown = this.onDown.bind(this);
        this.onMove = this.onMove.bind(this);
        this.onUp = this.onUp.bind(this);

        this.slider.addEventListener('pointerdown', this.onDown);
        this.engine.input.element.addEventListener('pointermove', this.onMove);
        this.engine.input.element.addEventListener('pointerup', this.onUp);
    }

    onDown(e) {
        if (!this.active || this.won) return;
        this.isDragging = true;
        this.startY = e.clientY;
        const rect = this.slider.getBoundingClientRect();
        const containerRect = this.container.getBoundingClientRect();
        this.startTop = rect.top - containerRect.top;
        this.slider.style.cursor = 'grabbing';
    }

    onMove(e) {
        if (!this.isDragging || !this.active || this.won) return;

        const deltaY = e.clientY - this.startY;
        let newTop = this.startTop + deltaY;

        const minTop = this.container.clientHeight * 0.1;
        const maxTop = this.container.clientHeight * 0.8;

        // Jamming Logic: If jammed, must release and restart gesture
        if (this.isJamming) return;

        if (newTop < minTop) newTop = minTop;
        if (newTop > maxTop) newTop = maxTop;

        // Progress Calculation (0 to 1)
        const currentProgress = (newTop - minTop) / (maxTop - minTop);
        
        // Single jam per round logic
        if (this.isJamRound && !this.isJamming && !this.jamResolved) {
            if ((this.targetDirection === 'UP' && currentProgress <= this.jamAtProgress) ||
                (this.targetDirection === 'DOWN' && currentProgress >= this.jamAtProgress)) {
                this.jam(newTop);
                return;
            }
        }

        this.slider.style.top = `${newTop}px`;
        this.slider.style.bottom = 'auto';

        // Win Conditions
        if (this.targetDirection === 'UP' && newTop <= minTop + 5) this.win();
        if (this.targetDirection === 'DOWN' && newTop >= maxTop - 5) this.win();
    }

    jam(top) {
        this.isJamming = true;
        this.jamTop = top;
        this.slider.style.background = '#ff4444';
        this.slider.style.boxShadow = `0 0 20px #ff4444`;
        this.engine.ui.instruction.textContent = "JAMMED! RESTART!";
        this.engine.ui.instruction.style.color = '#ff4444';
        
        // Haptic feedback if available
        if (window.navigator.vibrate) window.navigator.vibrate(50);
    }

    unjam() {
        this.isJamming = false;
        this.jamResolved = true; // Jam can only happen once per round
        this.slider.style.background = this.primaryColor;
        this.slider.style.boxShadow = `0 0 15px ${this.primaryColor}, inset 0 0 10px ${this.secondaryColor}`;
        this.engine.ui.instruction.textContent = this.targetDirection === 'UP' ? "ZIP UP!" : "ZIP DOWN!";
        this.engine.ui.instruction.style.color = '';
    }

    onUp() {
        this.isDragging = false;
        this.slider.style.cursor = 'grab';
        if (this.isJamming) this.unjam();
    }

    cleanup() {
        super.cleanup();
        this.engine.input.element.removeEventListener('pointermove', this.onMove);
        this.engine.input.element.removeEventListener('pointerup', this.onUp);
        this.engine.ui.instruction.style.color = '';
    }
}

